import { FiscalEvent } from '../../types/fiscal/FiscalEvent';

export default function FiscalEventErrors({ event }: { event: FiscalEvent }) {
  if (!event.messageDescription && !event.observations?.length) return null;
  return <div className="rounded border border-danger/30 bg-danger/5 p-4 text-sm">
    {event.messageDescription && <p className="font-medium text-danger">{event.messageCode ? `${event.messageCode}: ` : ''}{event.messageDescription}</p>}
    {!!event.observations?.length && <ul className="mt-2 list-disc pl-5">{event.observations.map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}</ul>}
  </div>;
}
